import React from 'react'
import stephenImage from '../img/stephen.webp'
import Spacer from '../lib/spacer'
import { useTranslation, useLang } from '../lib/i18n'
import { DEFAULT_LANG } from '../lib/locale'

// `<name>.md` is English, `<name>.<lang>.md` is that language.
const modules = import.meta.glob('./texts/*.md', { eager: true })

const TEXTS = {}

for (const [path, module] of Object.entries(modules)) {
    const [, name, lang = DEFAULT_LANG] = /\.\/texts\/([a-z0-9-]+?)(?:\.([a-z]{2}))?\.md$/.exec(path)
    TEXTS[lang] = { ...TEXTS[lang], [name]: module.html }
}

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'about' })
    const texts = { ...TEXTS[DEFAULT_LANG], ...TEXTS[useLang()] }

    return (
        <>
            <Spacer className="show-for-large" size={60} />
            <Spacer className="hide-for-large" size={30} />
            <div className="main grid-container">
                <div className="grid-x header">
                    <h1 className="h2">{t('heading')}</h1>
                </div>
                <Spacer size={20} />
                <div className="grid-x">
                    <div dangerouslySetInnerHTML={{ __html: texts.main }} />
                </div>
                <div className="grid-x align-center">
                    <div className="main column small-12 medium-6 person">
                        <div className="img-wrapper">
                            <img src={stephenImage} alt="Stephen Bradshaw" />
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: texts.stephen }} />
                    </div>
                </div>
            </div>
            <Spacer size={100} />
        </>
    )
}
